export default __webpack_public_path__ + "static/media/2.ea2b8598.png";